import { gql } from '@apollo/client';

export const creditDetailsInvoice = gql`
  query creditDetailsInvoice($id: ID!, $searchOptions: ConnectionSearchOptions, $filterOptions: InvoicesFilterOptions) {
    transactionAccount(id: $id) {
      id
      invoices(searchOptions: $searchOptions, filterOptions: $filterOptions) {
        totalCount
        nodes {
          id
          invoiceNumber
          sourceSystem
          paymentMethod
          paymentMethodId
          dueDate
          prePaymentCreditNotesAmount
          createdDate: createdTimestamp
          grandTotal: total
          paymentCurrency
          pricingCurrency
          pdfLink
          transactionAccountId
          status
          dunningStatus {
            errorCode
            nextPaymentAttempDate
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;
